import React from "react";

import HealtheraTable from "../../../Table/Table";

import { convertQuestionnairesToTable, prepareLoadingData } from "./table";

const Questionnaires = ({
  questionnaires,
  onRowsPerPageChange,
  onPageChange,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  total,
  isLoading,
}) => {
  const preparedData = isLoading
    ? prepareLoadingData(rowsPerPage)
    : convertQuestionnairesToTable(questionnaires);

  return (
    <HealtheraTable
      isLiveDashboard={false}
      data={preparedData}
      totalCount={total}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onChangePage={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      page={page}
      displayPagination
    />
  );
};

export default Questionnaires;
